import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const exactTitles = {
            '/': 'آوالون ام‌سی | بزرگترین سرور ماینکرفت بدراک ایران',
            '/ranks': 'فروشگاه رنک - آوالون ام‌سی',
            '/about': 'درباره ما - آوالون ام‌سی',
            '/contact': 'ارتباط با ما و پشتیبانی - آوالون ام‌سی',
            '/user-panel': 'پنل کاربری - آوالون ام‌سی',
            '/admin-panel': 'پنل مدیریت - آوالون ام‌سی',
            '/admin-login': 'ورود ادمین - آوالون ام‌سی',
            '/login': 'ورود به حساب کاربری - آوالون ام‌سی',
            '/register': 'ثبت‌نام در آوالون ام‌سی',
            '/forgot-password': 'بازیابی رمز عبور - آوالون ام‌سی',
            '/tickets': 'تیکت‌های پشتیبانی - آوالون ام‌سی',
        };

        let currentTitle = exactTitles[location.pathname];

        if (!currentTitle) {
            if (location.pathname.startsWith('/ranks/')) {
                const rankName = decodeURIComponent(location.pathname.replace('/ranks/', ''));
                currentTitle = `خرید رنک ${rankName} - آوالون ام‌سی`;
            } else if (location.pathname.startsWith('/tickets/')) {
                currentTitle = `مشاهده تیکت پشتیبانی - آوالون ام‌سی`;
            } else {
                currentTitle = 'آوالون ام‌سی | بزرگترین سرور ماینکرفت بدراک ایران';
            }
        }

        document.title = currentTitle;
    }, [location.pathname]);

    return null;
};

export default PageTitle;